import { memo, useEffect } from "react";
import { Flex, Text, Divider, Box, Radio, Skeleton } from "@mantine/core";
import { BiCheck } from "react-icons/bi";
import { GetValidCreditAllotmemtsQuery } from "src/generated/graphql";
import { TimeDiffType, getDateDiff } from "src/utils/dateHelper";

type ICredits = {
  myCredits: GetValidCreditAllotmemtsQuery["getValidCreditAllotmemts"];
  myCredit: string;
  setMyCredit: (e: string) => void;
  loading: boolean;
};

const CheckboxIcon = () => (
  <BiCheck color="green" style={{ position: "absolute", top: 0 }} size={20} />
);

function CreditSelection({
  myCredits,
  myCredit,
  setMyCredit,
  loading,
}: ICredits) {
  const handleChange = (id: string) => {
    setMyCredit(id);
  };

  useEffect(() => {
    setMyCredit("");
  }, []);

  return (
    <Box mt={"sm"}>
      <Text size={18} fw={500}>
        Credit Selection
      </Text>
      <Divider />

      {loading ? (
        <Skeleton height={60} circle mb="xl" />
      ) : (
        <Box>
          {myCredits?.map((credit) => {
            return (
              <Flex
                key={credit.id}
                justify={"space-between"}
                align={"center"}
                mt={"sm"}
                sx={{
                  background: "#F4F4F4",
                  borderRadius: 8,
                  border: credit.id === myCredit ? `1px solid #3C3C3C` : ``,
                  padding: "10px 15px",
                }}
                onClick={() => handleChange(credit.id)}
              >
                <Box>
                  <Text size={14} fw={600}>
                    {credit.name}
                  </Text>
                  <Text size={14} fw={600}>
                    {`${credit.count} Available`}
                  </Text>
                </Box>
                <Flex align={"center"} gap={5}>
                  <Box>
                    <Text size={12} fw={500}>
                      {credit.agreement?.name}
                    </Text>
                    <Text size={12} fw={500}>
                      {credit.expiresAt
                        ? `Expires in ${getDateDiff(
                            new Date(),
                            new Date(credit.expiresAt),
                            TimeDiffType.days
                          )} days`
                        : "No Expiration"}
                    </Text>
                  </Box>
                  <Radio
                    pl={3}
                    color="white"
                    checked={false}
                    icon={credit.id === myCredit ? CheckboxIcon : undefined}
                  />
                </Flex>
              </Flex>
            );
          })}
        </Box>
      )}
    </Box>
  );
}

export default memo(CreditSelection);
